import React, { useState } from "react";
import { Popover, IconButton, Grid, Button, Tooltip } from "@mui/material";
import GetAppIcon from "@mui/icons-material/GetApp";

const GridPopover = ({ title, icon, nameofButtons, handleClicks }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;

    return (
        <Grid item>
            <Tooltip title={title}>
                <IconButton
                    size="small"
                    aria-describedby={id}
                    onClick={handleClick}
                >
                    {icon}
                </IconButton>
            </Tooltip>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
            >
                <Grid item sx={{ p: "5px 5px 0 5px" }}>
                    {nameofButtons.map((name, index) => (
                        <Grid item key={index}>
                            <Button
                                onClick={() => {
                                    if (handleClicks[index]) {
                                        handleClicks[index]();
                                    }
                                    handleClose();
                                }}
                                sx={{ color: "black", textTransform: "none" }}
                            >
                                {name}
                            </Button>
                        </Grid>
                    ))}
                </Grid>
            </Popover>
        </Grid>
    );
};

export default GridPopover;
